import React from 'react'

import Main from './Main'

const MainSection = () => {
  return <Main />
}

export default MainSection
